function initProjectPaths() {
	const section = document.querySelector( '[data-project-paths]' );

	if ( ! section || ! ( 'IntersectionObserver' in window ) ) return;

	const iconViews = Array.from( section.querySelectorAll( '.project-paths__icon-view' ) );
	const slides = Array.from( section.querySelectorAll( '.project-paths__slide' ) );

	if ( ! iconViews.length || ! slides.length ) return;

	function setActiveIcon( id ) {
		iconViews.forEach( ( view ) => {
			view.classList.toggle( 'is-active', view.dataset.projectPath === id );
		} );
	}

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					setActiveIcon( entry.target.id );
				}
			} );
		},
		{
			rootMargin: '-20% 0% -20% 0%',
			threshold: 0.45,
		}
	);

	slides.forEach( ( slide ) => observer.observe( slide ) );
}

export default initProjectPaths;
